import { render, staticRenderFns } from "./todoItem.vue?vue&type=template&id=04dc1e6e&scoped=true"
import script from "./todoItem.vue?vue&type=script&lang=ts"
export * from "./todoItem.vue?vue&type=script&lang=ts"
import style0 from "./todoItem.vue?vue&type=style&index=0&id=04dc1e6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc1e6e",
  null
  
)

export default component.exports